import { Box, Flex, Heading } from "rebass";
import { height, maxWidth } from "styled-system";
import { LazyImage } from "../components/lazy-image";
import { DynamicNextLink } from "./dynamic-next-link";
import { theme } from "../styles/theme";
import styled from "styled-components";

// title: string,
// sponsors: {
//  sponsor_image: Prismic image,
//  sponsor_url: Prismic link to web
// }[]
const SponsorsGrid = ({ title, sponsors }) => {
  const Sponsors = () =>
    sponsors.map((item, index) => (
      <SponsorContainer
        key={index}
        width={[1, 1 / 2, 1 / 3]}
        maxWidth={258}
        mx="auto"
        mt={[4, 4, 4, 6]}
        px={[
          theme.space[3] / 2,
          theme.space[3] / 2,
          theme.space[3] / 2,
          theme.space[4] / 2
        ]}
        alignItems="center"
        justifyContent="center"
      >
        <DynamicNextLink link={{ internal: false, href: item.sponsor_url.url }}>
          <SponsorImage
            src={item.sponsor_image.url}
            alt={item.sponsor_image.alt}
          />
        </DynamicNextLink>
      </SponsorContainer>
    ));

  return (
    <Container maxWidth={1} mx="auto" my={[4, 4, 4, 6]} px={[3, 3, 3, 4]}>
      <GridTitle
        as="h2"
        width={1}
        fontSize={[4, 4, 6]}
        letterSpacing={1}
        textAlign="center"
        fontFamily="medium"
      >
        {title}
      </GridTitle>
      <Flex
        mx={[
          -theme.space[3] / 2,
          -theme.space[3] / 2,
          -theme.space[3] / 2,
          -theme.space[4] / 2
        ]}
        flexWrap="wrap"
        justifyContent="center"
      >
        <Sponsors />
      </Flex>
    </Container>
  );
};

const Container = styled(Box)`
  ${maxWidth}
`;

const GridTitle = styled(Heading)`
  text-transform: uppercase;
`;

const SponsorContainer = styled(Flex)`
  ${height}
  ${maxWidth}

  & a img {
    transition: opacity 0.3s cubic-bezier(0.465, 0.183, 0.153, 0.946);
  }
  & a:hover img {
    opacity: 0.7;
  }
`;

const SponsorImage = styled(LazyImage)`
  display: block;
  width: 100%;
  object-fit: contain;
  object-position: center;
`;

export { SponsorsGrid };
